import React from 'react';
import styled from "styled-components";
import HotLinks from "@atoms/hot.links";
import SearchIcon from "@icons/search.svg";

const SearchHotLinks = ({items, mapKey, className}) => {
    return (
        <SearchHotLinkBox key={mapKey} className={"py-24 py-lg-32 border-bottom border-gray200 " + (className ?? '')}>
            <strong className="h2 mb-16 d-block">جستجوهای مشابه</strong>

            <HotLinks items={items} className="" icon={<SearchIcon/>}/>
        </SearchHotLinkBox>
    );
};

export default React.memo(SearchHotLinks);

// styles

const SearchHotLinkBox = styled.div`
    @media (max-width: ${props => props.theme.screenXsMax}) {
        margin-top: 0;
        //margin-bottom: 32px;
        //border-bottom: 0 !important;
    }
`;
